//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.16.1.0 (NJsonSchema v10.7.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import axios, { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export class UserClient {
  private instance: AxiosInstance;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance ? instance : axios.create();

    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
  }

  /**
   * Login endpoint
   * @param body (optional) User's username and password
   * @return Login succeded
   */
  login(body: LoginDTO | undefined, cancelToken?: CancelToken | undefined): Promise<string> {
    let url_ = this.baseUrl + '/user/login';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json-patch+json',
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processLogin(_response);
      });
  }

  protected processLogin(response: AxiosResponse): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = resultData200 !== undefined ? resultData200 : <any>null;

      return Promise.resolve<string>(result200);
    } else if (status === 202) {
      const _responseText = response.data;
      return throwException('Two factor authentication needed', status, _responseText, _headers);
    } else if (status === 400) {
      const _responseText = response.data;
      return throwException('Unknow error', status, _responseText, _headers);
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException('User is not authorized to access', status, _responseText, _headers);
    } else if (status === 403) {
      const _responseText = response.data;
      return throwException('User doesnt have permission to login', status, _responseText, _headers);
    } else if (status === 404) {
      const _responseText = response.data;
      return throwException('User not found', status, _responseText, _headers);
    } else if (status === 409) {
      const _responseText = response.data;
      return throwException('User Lockout', status, _responseText, _headers);
    } else if (status === 419) {
      const _responseText = response.data;
      return throwException('Password Expired', status, _responseText, _headers);
    } else if (status === 500) {
      const _responseText = response.data;
      let result500: any = null;
      let resultData500 = _responseText;
      result500 = resultData500 !== undefined ? resultData500 : <any>null;

      return throwException('Error in token generation', status, _responseText, _headers, result500);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException('An unexpected server error occurred.', status, _responseText, _headers);
    }
    return Promise.resolve<string>(null as any);
  }

  /**
   * Set User Password using "magic-link" at first access, user must not be already active (EmailConfirmed)
   * @param securitycode unique security code that identity user
   * @param body (optional) new password
   * @return Password changed succesfully
   */
  firstAccessPost(
    securitycode: string,
    body: FirstAccessPasswordPayload | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ = this.baseUrl + '/user/first-access/{securitycode}';
    if (securitycode === undefined || securitycode === null)
      throw new Error("The parameter 'securitycode' must be defined.");
    url_ = url_.replace('{securitycode}', encodeURIComponent('' + securitycode));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json-patch+json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processFirstAccessPost(_response);
      });
  }

  protected processFirstAccessPost(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = resultData400 !== undefined ? resultData400 : <any>null;

      return throwException(
        'Validation password error or system consent false',
        status,
        _responseText,
        _headers,
        result400
      );
    } else if (status === 404) {
      const _responseText = response.data;
      return throwException('Invalid security code', status, _responseText, _headers);
    } else if (status === 409) {
      const _responseText = response.data;
      return throwException(
        'User already have set first-access password or is already enabled',
        status,
        _responseText,
        _headers
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException('An unexpected server error occurred.', status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
  }

  /**
     * Get user by "magic-link" at first access, check if user already active (EmailConfirmed) and if the "magic-link"
    exists
     * @param securitycode unique security code that identity user
     * @return Valid security code
     */
  firstAccessGet(securitycode: string, cancelToken?: CancelToken | undefined): Promise<UserProfileFirstAccessDTO> {
    let url_ = this.baseUrl + '/user/first-access/{securitycode}';
    if (securitycode === undefined || securitycode === null)
      throw new Error("The parameter 'securitycode' must be defined.");
    url_ = url_.replace('{securitycode}', encodeURIComponent('' + securitycode));
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processFirstAccessGet(_response);
      });
  }

  protected processFirstAccessGet(response: AxiosResponse): Promise<UserProfileFirstAccessDTO> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = UserProfileFirstAccessDTO.fromJS(resultData200);
      return Promise.resolve<UserProfileFirstAccessDTO>(result200);
    } else if (status === 404) {
      const _responseText = response.data;
      return throwException('Invalid security code', status, _responseText, _headers);
    } else if (status === 409) {
      const _responseText = response.data;
      return throwException(
        'User already have set first-access password or is already enabled',
        status,
        _responseText,
        _headers
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException('An unexpected server error occurred.', status, _responseText, _headers);
    }
    return Promise.resolve<UserProfileFirstAccessDTO>(null as any);
  }

  /**
   * Reset Password using "magic-link" providing a security code
   * @param securitycode unique security code that identity user
   * @param body (optional) new password
   * @return Password changed succesfully
   */
  resetPassword(
    securitycode: string,
    body: ResetPasswordPayload | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ = this.baseUrl + '/user/reset-password/{securitycode}';
    if (securitycode === undefined || securitycode === null)
      throw new Error("The parameter 'securitycode' must be defined.");
    url_ = url_.replace('{securitycode}', encodeURIComponent('' + securitycode));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json-patch+json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processResetPassword(_response);
      });
  }

  protected processResetPassword(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = resultData400 !== undefined ? resultData400 : <any>null;

      return throwException('Validation password error', status, _responseText, _headers, result400);
    } else if (status === 404) {
      const _responseText = response.data;
      return throwException('Invalid security code', status, _responseText, _headers);
    } else if (status === 500) {
      const _responseText = response.data;
      return throwException('Generic error', status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException('An unexpected server error occurred.', status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * Send Reset Password email
   * @param username (optional)
   * @return Email Sent
   */
  sendResetPassword(username: string | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
    let url_ = this.baseUrl + '/user/send-reset-password?';
    if (username === null) throw new Error("The parameter 'username' cannot be null.");
    else if (username !== undefined) url_ += 'username=' + encodeURIComponent('' + username) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'POST',
      url: url_,
      headers: {},
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processSendResetPassword(_response);
      });
  }

  protected processSendResetPassword(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);
    } else if (status === 404) {
      const _responseText = response.data;
      return throwException('User not found', status, _responseText, _headers);
    } else if (status === 500) {
      const _responseText = response.data;
      return throwException('Generic error', status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException('An unexpected server error occurred.', status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * Get User Profile, returns Guest profile if not authenticated (Auth)
   * @return User data ok
   */
  me(cancelToken?: CancelToken | undefined): Promise<UserProfileDTO> {
    let url_ = this.baseUrl + '/user/me';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processMe(_response);
      });
  }

  protected processMe(response: AxiosResponse): Promise<UserProfileDTO> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = UserProfileDTO.fromJS(resultData200);
      return Promise.resolve<UserProfileDTO>(result200);
    } else if (status === 500) {
      const _responseText = response.data;
      return throwException('Generic error', status, _responseText, _headers);
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException('Unauthorized', status, _responseText, _headers);
    } else if (status === 403) {
      const _responseText = response.data;
      return throwException('Forbidden', status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException('An unexpected server error occurred.', status, _responseText, _headers);
    }
    return Promise.resolve<UserProfileDTO>(null as any);
  }

  /**
   * Change current user password
   * @param body (optional)
   * @return Password changed
   */
  renewPassword(
    securitycode: string,
    body: ChangeMyPasswordPayload | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ = this.baseUrl + '/user/renew-password/{securitycode}';
    if (securitycode === undefined || securitycode === null)
      throw new Error("The parameter 'securitycode' must be defined.");
    url_ = url_.replace('{securitycode}', encodeURIComponent('' + securitycode));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json-patch+json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processRenewPassword(_response);
      });
  }

  protected processRenewPassword(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);
    } else if (status === 400) {
      const _responseText = response.data;
      return throwException('NewPassword validation error', status, _responseText, _headers);
    } else if (status === 403) {
      const _responseText = response.data;
      return throwException('Wrong old password', status, _responseText, _headers);
    } else if (status === 406) {
      const _responseText = response.data;
      return throwException('NewPassword is equal to OldPassword', status, _responseText, _headers);
    } else if (status === 422) {
      const _responseText = response.data;
      return throwException('NewPassword is different from ConfirmPassword', status, _responseText, _headers);
    } else if (status === 500) {
      const _responseText = response.data;
      return throwException('Generic error', status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException('An unexpected server error occurred.', status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * Change current user password (Auth)
   * @param body (optional)
   * @return Password changed
   */
  changePassword(body: ChangeMyPasswordPayload | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
    let url_ = this.baseUrl + '/user/change-password';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json-patch+json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processChangePassword(_response);
      });
  }

  protected processChangePassword(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);
    } else if (status === 400) {
      const _responseText = response.data;
      return throwException('NewPassword validation error', status, _responseText, _headers);
    } else if (status === 403) {
      const _responseText = response.data;
      return throwException('Wrong old password', status, _responseText, _headers);
    } else if (status === 406) {
      const _responseText = response.data;
      return throwException('NewPassword is equal to OldPassword', status, _responseText, _headers);
    } else if (status === 422) {
      const _responseText = response.data;
      return throwException('NewPassword is different from ConfirmPassword', status, _responseText, _headers);
    } else if (status === 500) {
      const _responseText = response.data;
      return throwException('Generic error', status, _responseText, _headers);
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException('Unauthorized', status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException('An unexpected server error occurred.', status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * Create a new Pulinet User (Auth roles: Administrator,Pulinet)
   * @param body (optional)
   * @return User created
   */
  newUser(
    body: BackOfficeUserDTO | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<CreateBackOfficeUserResponseDTO> {
    let url_ = this.baseUrl + '/user/new-user';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json-patch+json',
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processNewUser(_response);
      });
  }

  protected processNewUser(response: AxiosResponse): Promise<CreateBackOfficeUserResponseDTO> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = CreateBackOfficeUserResponseDTO.fromJS(resultData200);
      return Promise.resolve<CreateBackOfficeUserResponseDTO>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      return throwException('Cannot create User', status, _responseText, _headers);
    } else if (status === 409) {
      const _responseText = response.data;
      return throwException('Username already in use', status, _responseText, _headers);
    } else if (status === 500) {
      const _responseText = response.data;
      return throwException('Generic error', status, _responseText, _headers);
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException('Unauthorized', status, _responseText, _headers);
    } else if (status === 403) {
      const _responseText = response.data;
      return throwException('Forbidden', status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException('An unexpected server error occurred.', status, _responseText, _headers);
    }
    return Promise.resolve<CreateBackOfficeUserResponseDTO>(null as any);
  }

  /**
   * Get permissions role claims (Auth roles: Administrator)
   * @return Permissions
   */
  userPermissions(cancelToken?: CancelToken | undefined): Promise<InternalExternalBackOfficePermissions> {
    let url_ = this.baseUrl + '/user/user-permissions';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processUserPermissions(_response);
      });
  }

  protected processUserPermissions(response: AxiosResponse): Promise<InternalExternalBackOfficePermissions> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = InternalExternalBackOfficePermissions.fromJS(resultData200);
      return Promise.resolve<InternalExternalBackOfficePermissions>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      return throwException('Cannot read permissions role claim', status, _responseText, _headers);
    } else if (status === 500) {
      const _responseText = response.data;
      return throwException('Generic error', status, _responseText, _headers);
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException('Unauthorized', status, _responseText, _headers);
    } else if (status === 403) {
      const _responseText = response.data;
      return throwException('Forbidden', status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException('An unexpected server error occurred.', status, _responseText, _headers);
    }
    return Promise.resolve<InternalExternalBackOfficePermissions>(null as any);
  }

  /**
   * Generate impersonation url (Auth roles: Administrator,Pulinet)
   * @return Impersonation url
   */
  createImpersonation(userid: string, cancelToken?: CancelToken | undefined): Promise<string> {
    let url_ = this.baseUrl + '/user/create-impersonation/{userid}';
    if (userid === undefined || userid === null) throw new Error("The parameter 'userid' must be defined.");
    url_ = url_.replace('{userid}', encodeURIComponent('' + userid));
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'POST',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processCreateImpersonation(_response);
      });
  }

  protected processCreateImpersonation(response: AxiosResponse): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = resultData200 !== undefined ? resultData200 : <any>null;

      return Promise.resolve<string>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      return throwException('Cannot create url', status, _responseText, _headers);
    } else if (status === 500) {
      const _responseText = response.data;
      return throwException('Generic error', status, _responseText, _headers);
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException('Unauthorized', status, _responseText, _headers);
    } else if (status === 403) {
      const _responseText = response.data;
      return throwException('Forbidden', status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException('An unexpected server error occurred.', status, _responseText, _headers);
    }
    return Promise.resolve<string>(null as any);
  }

  /**
   * Generate a token to impersonate a user
   * @param secret (optional)
   * @return Impersonation url
   */
  impersonate(secret: string | undefined, cancelToken?: CancelToken | undefined): Promise<string> {
    let url_ = this.baseUrl + '/user/impersonate?';
    if (secret === null) throw new Error("The parameter 'secret' cannot be null.");
    else if (secret !== undefined) url_ += 'secret=' + encodeURIComponent('' + secret) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'POST',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processImpersonate(_response);
      });
  }

  protected processImpersonate(response: AxiosResponse): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = resultData200 !== undefined ? resultData200 : <any>null;

      return Promise.resolve<string>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      return throwException('Cannot create url', status, _responseText, _headers);
    } else if (status === 403) {
      const _responseText = response.data;
      return throwException('Authenticated user cannot impersonate', status, _responseText, _headers);
    } else if (status === 500) {
      const _responseText = response.data;
      return throwException('Generic error', status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException('An unexpected server error occurred.', status, _responseText, _headers);
    }
    return Promise.resolve<string>(null as any);
  }

  /**
   * Updates user general info (Auth roles: Administrator,Pulinet)
   * @param body (optional)
   * @return User update successful
   */
  userPut(userid: string, body: UserUpdateDTO | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
    let url_ = this.baseUrl + '/user/{userid}';
    if (userid === undefined || userid === null) throw new Error("The parameter 'userid' must be defined.");
    url_ = url_.replace('{userid}', encodeURIComponent('' + userid));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'PUT',
      url: url_,
      headers: {
        'Content-Type': 'application/json-patch+json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processUserPut(_response);
      });
  }

  protected processUserPut(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);
    } else if (status === 400) {
      const _responseText = response.data;
      return throwException('Invalid field values: some values are null or empty', status, _responseText, _headers);
    } else if (status === 404) {
      const _responseText = response.data;
      return throwException('User not found', status, _responseText, _headers);
    } else if (status === 500) {
      const _responseText = response.data;
      return throwException('A generic error occurred', status, _responseText, _headers);
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException('Unauthorized', status, _responseText, _headers);
    } else if (status === 403) {
      const _responseText = response.data;
      return throwException('Forbidden', status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException('An unexpected server error occurred.', status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * Delete user (Auth roles: Administrator,Pulinet)
   * @return User successfull deleted
   */
  userDelete(userid: string, cancelToken?: CancelToken | undefined): Promise<void> {
    let url_ = this.baseUrl + '/user/{userid}';
    if (userid === undefined || userid === null) throw new Error("The parameter 'userid' must be defined.");
    url_ = url_.replace('{userid}', encodeURIComponent('' + userid));
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'DELETE',
      url: url_,
      headers: {},
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processUserDelete(_response);
      });
  }

  protected processUserDelete(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);
    } else if (status === 400) {
      const _responseText = response.data;
      return throwException('Invalid userId', status, _responseText, _headers);
    } else if (status === 404) {
      const _responseText = response.data;
      return throwException('User not found', status, _responseText, _headers);
    } else if (status === 500) {
      const _responseText = response.data;
      return throwException('A generic error occurred', status, _responseText, _headers);
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException('Unauthorized', status, _responseText, _headers);
    } else if (status === 403) {
      const _responseText = response.data;
      return throwException('Forbidden', status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException('An unexpected server error occurred.', status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * Update pulinet users' permissions (Auth roles: Administrator)
   * @param body (optional)
   * @return Users permissions updated successfully
   */
  updateUserPermissions(
    body: UpdateUserPermissionsDTO | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ = this.baseUrl + '/user/update-user-permissions';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json-patch+json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processUpdateUserPermissions(_response);
      });
  }

  protected processUpdateUserPermissions(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);
    } else if (status === 400) {
      const _responseText = response.data;
      return throwException('Invalid field values: some values are null or empty', status, _responseText, _headers);
    } else if (status === 404) {
      const _responseText = response.data;
      return throwException('Some user not found', status, _responseText, _headers);
    } else if (status === 500) {
      const _responseText = response.data;
      return throwException('A generic error occurred', status, _responseText, _headers);
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException('Unauthorized', status, _responseText, _headers);
    } else if (status === 403) {
      const _responseText = response.data;
      return throwException('Forbidden', status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException('An unexpected server error occurred.', status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * Update customer users' permissions (Auth roles: Administrator)
   * @param body (optional)
   * @return Customer users permissions updated successfully
   */
  updateCustomerUserPermissions(
    body: UpdateCustomerUserPermissionsDTO | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ = this.baseUrl + '/user/update-customer-user-permissions';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json-patch+json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processUpdateCustomerUserPermissions(_response);
      });
  }

  protected processUpdateCustomerUserPermissions(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);
    } else if (status === 400) {
      const _responseText = response.data;
      return throwException('Invalid field values: some values are null or empty', status, _responseText, _headers);
    } else if (status === 404) {
      const _responseText = response.data;
      return throwException('Some user not found', status, _responseText, _headers);
    } else if (status === 500) {
      const _responseText = response.data;
      return throwException('A generic error occurred', status, _responseText, _headers);
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException('Unauthorized', status, _responseText, _headers);
    } else if (status === 403) {
      const _responseText = response.data;
      return throwException('Forbidden', status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException('An unexpected server error occurred.', status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * Updates back office user (Auth roles: Administrator,Pulinet)
   * @param body (optional)
   * @return User update successful
   */
  updatebackoffice(
    userid: string,
    body: BackOfficeUserUpdateDTO | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ = this.baseUrl + '/user/updatebackoffice/{userid}';
    if (userid === undefined || userid === null) throw new Error("The parameter 'userid' must be defined.");
    url_ = url_.replace('{userid}', encodeURIComponent('' + userid));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'PUT',
      url: url_,
      headers: {
        'Content-Type': 'application/json-patch+json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processUpdatebackoffice(_response);
      });
  }

  protected processUpdatebackoffice(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);
    } else if (status === 400) {
      const _responseText = response.data;
      return throwException('Invalid field values: some values are null or empty', status, _responseText, _headers);
    } else if (status === 404) {
      const _responseText = response.data;
      return throwException('User not found', status, _responseText, _headers);
    } else if (status === 500) {
      const _responseText = response.data;
      return throwException('A generic error occurred', status, _responseText, _headers);
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException('Unauthorized', status, _responseText, _headers);
    } else if (status === 403) {
      const _responseText = response.data;
      return throwException('Forbidden', status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException('An unexpected server error occurred.', status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * Updates user role permissions (claims) (Auth roles: Administrator,Pulinet)
   * @param body (optional)
   * @return User update successful
   */
  permissions(userid: string, body: UserClaimDTO | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
    let url_ = this.baseUrl + '/user/{userid}/permissions';
    if (userid === undefined || userid === null) throw new Error("The parameter 'userid' must be defined.");
    url_ = url_.replace('{userid}', encodeURIComponent('' + userid));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'PUT',
      url: url_,
      headers: {
        'Content-Type': 'application/json-patch+json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processPermissions(_response);
      });
  }

  protected processPermissions(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);
    } else if (status === 400) {
      const _responseText = response.data;
      return throwException('Invalid field values: some values are null or empty', status, _responseText, _headers);
    } else if (status === 404) {
      const _responseText = response.data;
      return throwException('User not found', status, _responseText, _headers);
    } else if (status === 500) {
      const _responseText = response.data;
      return throwException('A generic error occurred', status, _responseText, _headers);
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException('Unauthorized', status, _responseText, _headers);
    } else if (status === 403) {
      const _responseText = response.data;
      return throwException('Forbidden', status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException('An unexpected server error occurred.', status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * Enable or disable a user (Auth roles: Administrator,Pulinet)
   * @param body (optional)
   * @return Success
   */
  status(userid: string, body: boolean | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
    let url_ = this.baseUrl + '/user/{userid}/status';
    if (userid === undefined || userid === null) throw new Error("The parameter 'userid' must be defined.");
    url_ = url_.replace('{userid}', encodeURIComponent('' + userid));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'PUT',
      url: url_,
      headers: {
        'Content-Type': 'application/json-patch+json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processStatus(_response);
      });
  }

  protected processStatus(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);
    } else if (status === 500) {
      const _responseText = response.data;
      return throwException('A generic error occurred', status, _responseText, _headers);
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException('Unauthorized', status, _responseText, _headers);
    } else if (status === 403) {
      const _responseText = response.data;
      return throwException('Forbidden', status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException('An unexpected server error occurred.', status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * Get all pulinet users list (Auth roles: Administrator,Pulinet)
   * @param query (optional) Serialization of QueryInfo data Type
   * @return Return all pulinet users
   */
  pulinet(
    query: string | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<BackOfficeUserListItemDTOQueryResult> {
    let url_ = this.baseUrl + '/user/pulinet?';
    if (query === null) throw new Error("The parameter 'query' cannot be null.");
    else if (query !== undefined) url_ += 'query=' + encodeURIComponent('' + query) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processPulinet(_response);
      });
  }

  protected processPulinet(response: AxiosResponse): Promise<BackOfficeUserListItemDTOQueryResult> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = BackOfficeUserListItemDTOQueryResult.fromJS(resultData200);
      return Promise.resolve<BackOfficeUserListItemDTOQueryResult>(result200);
    } else if (status === 500) {
      const _responseText = response.data;
      return throwException('A generic error occurred', status, _responseText, _headers);
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException('Unauthorized', status, _responseText, _headers);
    } else if (status === 403) {
      const _responseText = response.data;
      return throwException('Forbidden', status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException('An unexpected server error occurred.', status, _responseText, _headers);
    }
    return Promise.resolve<BackOfficeUserListItemDTOQueryResult>(null as any);
  }

  /**
   * Get user by Id (Auth roles: Administrator,Pulinet)
   * @return Return user
   */
  details(userid: string, cancelToken?: CancelToken | undefined): Promise<BackOfficeUserDTO> {
    let url_ = this.baseUrl + '/user/{userid}/details';
    if (userid === undefined || userid === null) throw new Error("The parameter 'userid' must be defined.");
    url_ = url_.replace('{userid}', encodeURIComponent('' + userid));
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processDetails(_response);
      });
  }

  protected processDetails(response: AxiosResponse): Promise<BackOfficeUserDTO> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = BackOfficeUserDTO.fromJS(resultData200);
      return Promise.resolve<BackOfficeUserDTO>(result200);
    } else if (status === 500) {
      const _responseText = response.data;
      return throwException('A generic error occurred', status, _responseText, _headers);
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException('Unauthorized', status, _responseText, _headers);
    } else if (status === 403) {
      const _responseText = response.data;
      return throwException('Forbidden', status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException('An unexpected server error occurred.', status, _responseText, _headers);
    }
    return Promise.resolve<BackOfficeUserDTO>(null as any);
  }

  /**
   * Send Activation Email to User with role Pulinet/Customer (Auth roles: Administrator,Pulinet)
   * @return Email sent
   */
  sendActivationEmail(id: string, cancelToken?: CancelToken | undefined): Promise<void> {
    let url_ = this.baseUrl + '/user/send-activation-email/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'POST',
      url: url_,
      headers: {},
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processSendActivationEmail(_response);
      });
  }

  protected processSendActivationEmail(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);
    } else if (status === 404) {
      const _responseText = response.data;
      return throwException('User not found', status, _responseText, _headers);
    } else if (status === 400) {
      const _responseText = response.data;
      return throwException('User already active', status, _responseText, _headers);
    } else if (status === 500) {
      const _responseText = response.data;
      return throwException('A generic error occurred', status, _responseText, _headers);
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException('Unauthorized', status, _responseText, _headers);
    } else if (status === 403) {
      const _responseText = response.data;
      return throwException('Forbidden', status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException('An unexpected server error occurred.', status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
  }
}

export class AtiDetailDTO implements IAtiDetailDTO {
  isAti?: boolean;
  image?: string | undefined;
  atiName?: string | undefined;

  constructor(data?: IAtiDetailDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.isAti = _data['isAti'];
      this.image = _data['image'];
      this.atiName = _data['atiName'];
    }
  }

  static fromJS(data: any): AtiDetailDTO {
    data = typeof data === 'object' ? data : {};
    let result = new AtiDetailDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['isAti'] = this.isAti;
    data['image'] = this.image;
    data['atiName'] = this.atiName;
    return data;
  }
}

export interface IAtiDetailDTO {
  isAti?: boolean;
  image?: string | undefined;
  atiName?: string | undefined;
}

/** 0 = USER_PERMISSION_CLIENTS 1 = USER_PERMISSION_CLIENTS_USERS 2 = USER_PERMISSION_CLIENTS_BILLING 3 = USER_PERMISSION_JOBTASKS 4 = USER_PERMISSION_SITES 5 = USER_PERMISSION_TICKETS 6 = USER_PERMISSION_DOCUMENTS 7 = USER_PERMISSION_COMUNICATIONS 8 = USER_PERMISSION_CONTRADICTORY_REQUESTS 9 = USER_PERMISSION_NEWS 10 = USER_PERMISSION_SURVEY 11 = USER_PERMISSION_QGIS 12 = USER_PERMISSION_SERVICES 13 = USER_PERMISSION_EMPLOYEES 14 = USER_PERMISSION_PULINET_CONTACTS 16 = USER_PERMISSION_SYNC 17 = USER_PERMISSION_EQUIPMENT 18 = USER_PERMISSION_ECONOMICS 19 = USER_PERMISSION_REPORTS */
export enum BackOfficePermissionRoleClaim {
  USER_PERMISSION_CLIENTS = 0,
  USER_PERMISSION_CLIENTS_USERS = 1,
  USER_PERMISSION_CLIENTS_BILLING = 2,
  USER_PERMISSION_JOBTASKS = 3,
  USER_PERMISSION_SITES = 4,
  USER_PERMISSION_TICKETS = 5,
  USER_PERMISSION_DOCUMENTS = 6,
  USER_PERMISSION_COMUNICATIONS = 7,
  USER_PERMISSION_CONTRADICTORY_REQUESTS = 8,
  USER_PERMISSION_NEWS = 9,
  USER_PERMISSION_SURVEY = 10,
  USER_PERMISSION_QGIS = 11,
  USER_PERMISSION_SERVICES = 12,
  USER_PERMISSION_EMPLOYEES = 13,
  USER_PERMISSION_PULINET_CONTACTS = 14,
  USER_PERMISSION_SYNC = 16,
  USER_PERMISSION_EQUIPMENT = 17,
  USER_PERMISSION_ECONOMICS = 18,
  USER_PERMISSION_REPORTS = 19,
}

export class BackOfficeUserDTO implements IBackOfficeUserDTO {
  firstName?: string | undefined;
  surname?: string | undefined;
  username?: string | undefined;
  email?: string | undefined;
  isExternal?: boolean;
  isEnabled?: boolean;
  companyName?: string | undefined;
  permissionsRoleClaim?: BackOfficePermissionRoleClaim[] | undefined;
  sites?: PublishedSiteListItemDTO[] | undefined;

  constructor(data?: IBackOfficeUserDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.firstName = _data['firstName'];
      this.surname = _data['surname'];
      this.username = _data['username'];
      this.email = _data['email'];
      this.isExternal = _data['isExternal'];
      this.isEnabled = _data['isEnabled'];
      this.companyName = _data['companyName'];
      if (Array.isArray(_data['permissionsRoleClaim'])) {
        this.permissionsRoleClaim = [] as any;
        for (let item of _data['permissionsRoleClaim']) this.permissionsRoleClaim!.push(item);
      }
      if (Array.isArray(_data['sites'])) {
        this.sites = [] as any;
        for (let item of _data['sites']) this.sites!.push(PublishedSiteListItemDTO.fromJS(item));
      }
    }
  }

  static fromJS(data: any): BackOfficeUserDTO {
    data = typeof data === 'object' ? data : {};
    let result = new BackOfficeUserDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['firstName'] = this.firstName;
    data['surname'] = this.surname;
    data['username'] = this.username;
    data['email'] = this.email;
    data['isExternal'] = this.isExternal;
    data['isEnabled'] = this.isEnabled;
    data['companyName'] = this.companyName;
    if (Array.isArray(this.permissionsRoleClaim)) {
      data['permissionsRoleClaim'] = [];
      for (let item of this.permissionsRoleClaim) data['permissionsRoleClaim'].push(item);
    }
    if (Array.isArray(this.sites)) {
      data['sites'] = [];
      for (let item of this.sites) data['sites'].push(item.toJSON());
    }
    return data;
  }
}

export interface IBackOfficeUserDTO {
  firstName?: string | undefined;
  surname?: string | undefined;
  username?: string | undefined;
  email?: string | undefined;
  isExternal?: boolean;
  isEnabled?: boolean;
  companyName?: string | undefined;
  permissionsRoleClaim?: BackOfficePermissionRoleClaim[] | undefined;
  sites?: PublishedSiteListItemDTO[] | undefined;
}

export class BackOfficeUserListItemDTO implements IBackOfficeUserListItemDTO {
  id?: string | undefined;
  name?: string | undefined;
  surname?: string | undefined;
  email?: string | undefined;
  username?: string | undefined;
  active?: boolean;
  companyName?: string | undefined;
  isExternal?: boolean;
  enabled?: boolean;
  activationLink?: string | undefined;
  subRoles?: BackOfficePermissionRoleClaim[] | undefined;

  constructor(data?: IBackOfficeUserListItemDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.name = _data['name'];
      this.surname = _data['surname'];
      this.email = _data['email'];
      this.username = _data['username'];
      this.active = _data['active'];
      this.companyName = _data['companyName'];
      this.isExternal = _data['isExternal'];
      this.enabled = _data['enabled'];
      this.activationLink = _data['activationLink'];
      if (Array.isArray(_data['subRoles'])) {
        this.subRoles = [] as any;
        for (let item of _data['subRoles']) this.subRoles!.push(item);
      }
    }
  }

  static fromJS(data: any): BackOfficeUserListItemDTO {
    data = typeof data === 'object' ? data : {};
    let result = new BackOfficeUserListItemDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['name'] = this.name;
    data['surname'] = this.surname;
    data['email'] = this.email;
    data['username'] = this.username;
    data['active'] = this.active;
    data['companyName'] = this.companyName;
    data['isExternal'] = this.isExternal;
    data['enabled'] = this.enabled;
    data['activationLink'] = this.activationLink;
    if (Array.isArray(this.subRoles)) {
      data['subRoles'] = [];
      for (let item of this.subRoles) data['subRoles'].push(item);
    }
    return data;
  }
}

export interface IBackOfficeUserListItemDTO {
  id?: string | undefined;
  name?: string | undefined;
  surname?: string | undefined;
  email?: string | undefined;
  username?: string | undefined;
  active?: boolean;
  companyName?: string | undefined;
  isExternal?: boolean;
  enabled?: boolean;
  activationLink?: string | undefined;
  subRoles?: BackOfficePermissionRoleClaim[] | undefined;
}

export class BackOfficeUserListItemDTOQueryResult implements IBackOfficeUserListItemDTOQueryResult {
  data?: BackOfficeUserListItemDTO[] | undefined;
  total?: number;

  constructor(data?: IBackOfficeUserListItemDTOQueryResult) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['data'])) {
        this.data = [] as any;
        for (let item of _data['data']) this.data!.push(BackOfficeUserListItemDTO.fromJS(item));
      }
      this.total = _data['total'];
    }
  }

  static fromJS(data: any): BackOfficeUserListItemDTOQueryResult {
    data = typeof data === 'object' ? data : {};
    let result = new BackOfficeUserListItemDTOQueryResult();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.data)) {
      data['data'] = [];
      for (let item of this.data) data['data'].push(item.toJSON());
    }
    data['total'] = this.total;
    return data;
  }
}

export interface IBackOfficeUserListItemDTOQueryResult {
  data?: BackOfficeUserListItemDTO[] | undefined;
  total?: number;
}

export class BackOfficeUserUpdateDTO implements IBackOfficeUserUpdateDTO {
  firstName?: string | undefined;
  surname?: string | undefined;
  email?: string | undefined;
  companyName?: string | undefined;
  permissionsRoleClaim?: BackOfficePermissionRoleClaim[] | undefined;
  sites?: PublishedSiteListItemDTO[] | undefined;

  constructor(data?: IBackOfficeUserUpdateDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.firstName = _data['firstName'];
      this.surname = _data['surname'];
      this.email = _data['email'];
      this.companyName = _data['companyName'];
      if (Array.isArray(_data['permissionsRoleClaim'])) {
        this.permissionsRoleClaim = [] as any;
        for (let item of _data['permissionsRoleClaim']) this.permissionsRoleClaim!.push(item);
      }
      if (Array.isArray(_data['sites'])) {
        this.sites = [] as any;
        for (let item of _data['sites']) this.sites!.push(PublishedSiteListItemDTO.fromJS(item));
      }
    }
  }

  static fromJS(data: any): BackOfficeUserUpdateDTO {
    data = typeof data === 'object' ? data : {};
    let result = new BackOfficeUserUpdateDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['firstName'] = this.firstName;
    data['surname'] = this.surname;
    data['email'] = this.email;
    data['companyName'] = this.companyName;
    if (Array.isArray(this.permissionsRoleClaim)) {
      data['permissionsRoleClaim'] = [];
      for (let item of this.permissionsRoleClaim) data['permissionsRoleClaim'].push(item);
    }
    if (Array.isArray(this.sites)) {
      data['sites'] = [];
      for (let item of this.sites) data['sites'].push(item.toJSON());
    }
    return data;
  }
}

export interface IBackOfficeUserUpdateDTO {
  firstName?: string | undefined;
  surname?: string | undefined;
  email?: string | undefined;
  companyName?: string | undefined;
  permissionsRoleClaim?: BackOfficePermissionRoleClaim[] | undefined;
  sites?: PublishedSiteListItemDTO[] | undefined;
}

export class ChangeMyPasswordPayload implements IChangeMyPasswordPayload {
  oldPassword?: string | undefined;
  newPassword?: string | undefined;
  confirmPassword?: string | undefined;

  constructor(data?: IChangeMyPasswordPayload) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.oldPassword = _data['oldPassword'];
      this.newPassword = _data['newPassword'];
      this.confirmPassword = _data['confirmPassword'];
    }
  }

  static fromJS(data: any): ChangeMyPasswordPayload {
    data = typeof data === 'object' ? data : {};
    let result = new ChangeMyPasswordPayload();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['oldPassword'] = this.oldPassword;
    data['newPassword'] = this.newPassword;
    data['confirmPassword'] = this.confirmPassword;
    return data;
  }
}

export interface IChangeMyPasswordPayload {
  oldPassword?: string | undefined;
  newPassword?: string | undefined;
  confirmPassword?: string | undefined;
}

export class CreateBackOfficeUserResponseDTO implements ICreateBackOfficeUserResponseDTO {
  userId?: string | undefined;
  activationLink?: string | undefined;

  constructor(data?: ICreateBackOfficeUserResponseDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.userId = _data['userId'];
      this.activationLink = _data['activationLink'];
    }
  }

  static fromJS(data: any): CreateBackOfficeUserResponseDTO {
    data = typeof data === 'object' ? data : {};
    let result = new CreateBackOfficeUserResponseDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['userId'] = this.userId;
    data['activationLink'] = this.activationLink;
    return data;
  }
}

export interface ICreateBackOfficeUserResponseDTO {
  userId?: string | undefined;
  activationLink?: string | undefined;
}

/** 0 = CUSTOMER_PERMISSION_SITE 1 = CUSTOMER_PERMISSION_PLANNING 2 = CUSTOMER_PERMISSION_CALENDAR 3 = CUSTOMER_PERMISSION_EMPLOYEE 4 = CUSTOMER_PERMISSION_EMPLOYEE_STAMPINGS 5 = CUSTOMER_PERMISSION_DOCUMENTS 6 = CUSTOMER_PERMISSION_COMMUNICATIONS 7 = CUSTOMER_PERMISSION_CONTACTS 8 = CUSTOMER_PERMISSION_QUALITY_CONTROLS 9 = CUSTOMER_PERMISSION_QUALITY_REPORTS 10 = CUSTOMER_PERMISSION_QUALITY_STATS 11 = CUSTOMER_PERMISSION_KIOSKS 12 = CUSTOMER_PERMISSION_REAL_ESTATE_REGISTRY 13 = CUSTOMER_PERMISSION_BILLING 14 = CUSTOMER_PERMISSION_COMMUNICATIONS_ALL_TICKETS 15 = CUSTOMER_PERMISSION_SITE_EQUIPMENTS 16 = CUSTOMER_PERMISSION_ECONOMICS */
export enum CustomerRoleClaim {
  CUSTOMER_PERMISSION_SITE = 0,
  CUSTOMER_PERMISSION_PLANNING = 1,
  CUSTOMER_PERMISSION_CALENDAR = 2,
  CUSTOMER_PERMISSION_EMPLOYEE = 3,
  CUSTOMER_PERMISSION_EMPLOYEE_STAMPINGS = 4,
  CUSTOMER_PERMISSION_DOCUMENTS = 5,
  CUSTOMER_PERMISSION_COMMUNICATIONS = 6,
  CUSTOMER_PERMISSION_CONTACTS = 7,
  CUSTOMER_PERMISSION_QUALITY_CONTROLS = 8,
  CUSTOMER_PERMISSION_QUALITY_REPORTS = 9,
  CUSTOMER_PERMISSION_QUALITY_STATS = 10,
  CUSTOMER_PERMISSION_KIOSKS = 11,
  CUSTOMER_PERMISSION_REAL_ESTATE_REGISTRY = 12,
  CUSTOMER_PERMISSION_BILLING = 13,
  CUSTOMER_PERMISSION_COMMUNICATIONS_ALL_TICKETS = 14,
  CUSTOMER_PERMISSION_SITE_EQUIPMENTS = 15,
  CUSTOMER_PERMISSION_ECONOMICS = 16,
}

export class CustomerUserPermissionsPerUser implements ICustomerUserPermissionsPerUser {
  userId?: string | undefined;
  customerSubRoles?: CustomerRoleClaim[] | undefined;

  constructor(data?: ICustomerUserPermissionsPerUser) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.userId = _data['userId'];
      if (Array.isArray(_data['customerSubRoles'])) {
        this.customerSubRoles = [] as any;
        for (let item of _data['customerSubRoles']) this.customerSubRoles!.push(item);
      }
    }
  }

  static fromJS(data: any): CustomerUserPermissionsPerUser {
    data = typeof data === 'object' ? data : {};
    let result = new CustomerUserPermissionsPerUser();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['userId'] = this.userId;
    if (Array.isArray(this.customerSubRoles)) {
      data['customerSubRoles'] = [];
      for (let item of this.customerSubRoles) data['customerSubRoles'].push(item);
    }
    return data;
  }
}

export interface ICustomerUserPermissionsPerUser {
  userId?: string | undefined;
  customerSubRoles?: CustomerRoleClaim[] | undefined;
}

export class FirstAccessPasswordPayload implements IFirstAccessPasswordPayload {
  password?: string | undefined;
  systemEmailsConsent?: boolean;
  promotionalNewsEmailsConsent?: boolean;

  constructor(data?: IFirstAccessPasswordPayload) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.password = _data['password'];
      this.systemEmailsConsent = _data['systemEmailsConsent'];
      this.promotionalNewsEmailsConsent = _data['promotionalNewsEmailsConsent'];
    }
  }

  static fromJS(data: any): FirstAccessPasswordPayload {
    data = typeof data === 'object' ? data : {};
    let result = new FirstAccessPasswordPayload();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['password'] = this.password;
    data['systemEmailsConsent'] = this.systemEmailsConsent;
    data['promotionalNewsEmailsConsent'] = this.promotionalNewsEmailsConsent;
    return data;
  }
}

export interface IFirstAccessPasswordPayload {
  password?: string | undefined;
  systemEmailsConsent?: boolean;
  promotionalNewsEmailsConsent?: boolean;
}

export class InternalExternalBackOfficePermissions implements IInternalExternalBackOfficePermissions {
  internalRoleClaims?: BackOfficePermissionRoleClaim[] | undefined;
  externalRoleClaims?: BackOfficePermissionRoleClaim[] | undefined;

  constructor(data?: IInternalExternalBackOfficePermissions) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['internalRoleClaims'])) {
        this.internalRoleClaims = [] as any;
        for (let item of _data['internalRoleClaims']) this.internalRoleClaims!.push(item);
      }
      if (Array.isArray(_data['externalRoleClaims'])) {
        this.externalRoleClaims = [] as any;
        for (let item of _data['externalRoleClaims']) this.externalRoleClaims!.push(item);
      }
    }
  }

  static fromJS(data: any): InternalExternalBackOfficePermissions {
    data = typeof data === 'object' ? data : {};
    let result = new InternalExternalBackOfficePermissions();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.internalRoleClaims)) {
      data['internalRoleClaims'] = [];
      for (let item of this.internalRoleClaims) data['internalRoleClaims'].push(item);
    }
    if (Array.isArray(this.externalRoleClaims)) {
      data['externalRoleClaims'] = [];
      for (let item of this.externalRoleClaims) data['externalRoleClaims'].push(item);
    }
    return data;
  }
}

export interface IInternalExternalBackOfficePermissions {
  internalRoleClaims?: BackOfficePermissionRoleClaim[] | undefined;
  externalRoleClaims?: BackOfficePermissionRoleClaim[] | undefined;
}

export class LoginDTO implements ILoginDTO {
  username?: string | undefined;
  password?: string | undefined;

  constructor(data?: ILoginDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.username = _data['username'];
      this.password = _data['password'];
    }
  }

  static fromJS(data: any): LoginDTO {
    data = typeof data === 'object' ? data : {};
    let result = new LoginDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['username'] = this.username;
    data['password'] = this.password;
    return data;
  }
}

export interface ILoginDTO {
  username?: string | undefined;
  password?: string | undefined;
}

export class ProfileInfoDTO implements IProfileInfoDTO {
  emailConfirmed?: boolean;
  companyName?: string | undefined;

  constructor(data?: IProfileInfoDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.emailConfirmed = _data['emailConfirmed'];
      this.companyName = _data['companyName'];
    }
  }

  static fromJS(data: any): ProfileInfoDTO {
    data = typeof data === 'object' ? data : {};
    let result = new ProfileInfoDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['emailConfirmed'] = this.emailConfirmed;
    data['companyName'] = this.companyName;
    return data;
  }
}

export interface IProfileInfoDTO {
  emailConfirmed?: boolean;
  companyName?: string | undefined;
}

export class PublishedSiteListItemDTO implements IPublishedSiteListItemDTO {
  siteCode?: string | undefined;
  siteName?: string | undefined;
  jobTaskId?: string | undefined;
  jobTaskDescription?: string | undefined;
  address?: string | undefined;
  city?: string | undefined;
  lastServiceDay?: Date | undefined;
  startHour?: string | undefined;
  endHour?: string | undefined;
  operatingSegment?: string | undefined;
  isOnDuty?: boolean;
  client?: string | undefined;
  clientCode?: string | undefined;

  constructor(data?: IPublishedSiteListItemDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.siteCode = _data['siteCode'];
      this.siteName = _data['siteName'];
      this.jobTaskId = _data['jobTaskId'];
      this.jobTaskDescription = _data['jobTaskDescription'];
      this.address = _data['address'];
      this.city = _data['city'];
      this.lastServiceDay = _data['lastServiceDay'] ? new Date(_data['lastServiceDay'].toString()) : <any>undefined;
      this.startHour = _data['startHour'];
      this.endHour = _data['endHour'];
      this.operatingSegment = _data['operatingSegment'];
      this.isOnDuty = _data['isOnDuty'];
      this.client = _data['client'];
      this.clientCode = _data['clientCode'];
    }
  }

  static fromJS(data: any): PublishedSiteListItemDTO {
    data = typeof data === 'object' ? data : {};
    let result = new PublishedSiteListItemDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['siteCode'] = this.siteCode;
    data['siteName'] = this.siteName;
    data['jobTaskId'] = this.jobTaskId;
    data['jobTaskDescription'] = this.jobTaskDescription;
    data['address'] = this.address;
    data['city'] = this.city;
    data['lastServiceDay'] = this.lastServiceDay ? this.lastServiceDay.toISOString() : <any>undefined;
    data['startHour'] = this.startHour;
    data['endHour'] = this.endHour;
    data['operatingSegment'] = this.operatingSegment;
    data['isOnDuty'] = this.isOnDuty;
    data['client'] = this.client;
    data['clientCode'] = this.clientCode;
    return data;
  }
}

export interface IPublishedSiteListItemDTO {
  siteCode?: string | undefined;
  siteName?: string | undefined;
  jobTaskId?: string | undefined;
  jobTaskDescription?: string | undefined;
  address?: string | undefined;
  city?: string | undefined;
  lastServiceDay?: Date | undefined;
  startHour?: string | undefined;
  endHour?: string | undefined;
  operatingSegment?: string | undefined;
  isOnDuty?: boolean;
  client?: string | undefined;
  clientCode?: string | undefined;
}

export class ResetPasswordPayload implements IResetPasswordPayload {
  password?: string | undefined;

  constructor(data?: IResetPasswordPayload) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.password = _data['password'];
    }
  }

  static fromJS(data: any): ResetPasswordPayload {
    data = typeof data === 'object' ? data : {};
    let result = new ResetPasswordPayload();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['password'] = this.password;
    return data;
  }
}

export interface IResetPasswordPayload {
  password?: string | undefined;
}

export class UpdateCustomerUserPermissionsDTO implements IUpdateCustomerUserPermissionsDTO {
  data?: CustomerUserPermissionsPerUser[] | undefined;

  constructor(data?: IUpdateCustomerUserPermissionsDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['data'])) {
        this.data = [] as any;
        for (let item of _data['data']) this.data!.push(CustomerUserPermissionsPerUser.fromJS(item));
      }
    }
  }

  static fromJS(data: any): UpdateCustomerUserPermissionsDTO {
    data = typeof data === 'object' ? data : {};
    let result = new UpdateCustomerUserPermissionsDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.data)) {
      data['data'] = [];
      for (let item of this.data) data['data'].push(item.toJSON());
    }
    return data;
  }
}

export interface IUpdateCustomerUserPermissionsDTO {
  data?: CustomerUserPermissionsPerUser[] | undefined;
}

export class UpdateUserPermissionsDTO implements IUpdateUserPermissionsDTO {
  data?: UserPermissionsPerUser[] | undefined;

  constructor(data?: IUpdateUserPermissionsDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['data'])) {
        this.data = [] as any;
        for (let item of _data['data']) this.data!.push(UserPermissionsPerUser.fromJS(item));
      }
    }
  }

  static fromJS(data: any): UpdateUserPermissionsDTO {
    data = typeof data === 'object' ? data : {};
    let result = new UpdateUserPermissionsDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.data)) {
      data['data'] = [];
      for (let item of this.data) data['data'].push(item.toJSON());
    }
    return data;
  }
}

export interface IUpdateUserPermissionsDTO {
  data?: UserPermissionsPerUser[] | undefined;
}

export class UserClaimDTO implements IUserClaimDTO {
  customerSubRoles?: CustomerRoleClaim[] | undefined;

  constructor(data?: IUserClaimDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['customerSubRoles'])) {
        this.customerSubRoles = [] as any;
        for (let item of _data['customerSubRoles']) this.customerSubRoles!.push(item);
      }
    }
  }

  static fromJS(data: any): UserClaimDTO {
    data = typeof data === 'object' ? data : {};
    let result = new UserClaimDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.customerSubRoles)) {
      data['customerSubRoles'] = [];
      for (let item of this.customerSubRoles) data['customerSubRoles'].push(item);
    }
    return data;
  }
}

export interface IUserClaimDTO {
  customerSubRoles?: CustomerRoleClaim[] | undefined;
}

export class UserPermissionsPerUser implements IUserPermissionsPerUser {
  userId?: string | undefined;
  permissionsRoleClaim?: BackOfficePermissionRoleClaim[] | undefined;

  constructor(data?: IUserPermissionsPerUser) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.userId = _data['userId'];
      if (Array.isArray(_data['permissionsRoleClaim'])) {
        this.permissionsRoleClaim = [] as any;
        for (let item of _data['permissionsRoleClaim']) this.permissionsRoleClaim!.push(item);
      }
    }
  }

  static fromJS(data: any): UserPermissionsPerUser {
    data = typeof data === 'object' ? data : {};
    let result = new UserPermissionsPerUser();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['userId'] = this.userId;
    if (Array.isArray(this.permissionsRoleClaim)) {
      data['permissionsRoleClaim'] = [];
      for (let item of this.permissionsRoleClaim) data['permissionsRoleClaim'].push(item);
    }
    return data;
  }
}

export interface IUserPermissionsPerUser {
  userId?: string | undefined;
  permissionsRoleClaim?: BackOfficePermissionRoleClaim[] | undefined;
}

export class UserProfileDTO implements IUserProfileDTO {
  firstName?: string | undefined;
  lastName?: string | undefined;
  roles?: string[] | undefined;
  username?: string | undefined;
  isAuthenticated?: boolean;
  profile?: ProfileInfoDTO;
  newDocuments?: number;
  newBillingDocuments?: number;
  newTickets?: number;
  newCommunications?: number;
  hasNotifications?: boolean;
  id?: string | undefined;
  ati?: AtiDetailDTO;
  customerSubRoles?: CustomerRoleClaim[] | undefined;
  backOfficeSubRoles?: BackOfficePermissionRoleClaim[] | undefined;

  constructor(data?: IUserProfileDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.firstName = _data['firstName'];
      this.lastName = _data['lastName'];
      if (Array.isArray(_data['roles'])) {
        this.roles = [] as any;
        for (let item of _data['roles']) this.roles!.push(item);
      }
      this.username = _data['username'];
      this.isAuthenticated = _data['isAuthenticated'];
      this.profile = _data['profile'] ? ProfileInfoDTO.fromJS(_data['profile']) : <any>undefined;
      this.newDocuments = _data['newDocuments'];
      this.newBillingDocuments = _data['newBillingDocuments'];
      this.newTickets = _data['newTickets'];
      this.newCommunications = _data['newCommunications'];
      this.hasNotifications = _data['hasNotifications'];
      this.id = _data['id'];
      this.ati = _data['ati'] ? AtiDetailDTO.fromJS(_data['ati']) : <any>undefined;
      if (Array.isArray(_data['customerSubRoles'])) {
        this.customerSubRoles = [] as any;
        for (let item of _data['customerSubRoles']) this.customerSubRoles!.push(item);
      }
      if (Array.isArray(_data['backOfficeSubRoles'])) {
        this.backOfficeSubRoles = [] as any;
        for (let item of _data['backOfficeSubRoles']) this.backOfficeSubRoles!.push(item);
      }
    }
  }

  static fromJS(data: any): UserProfileDTO {
    data = typeof data === 'object' ? data : {};
    let result = new UserProfileDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['firstName'] = this.firstName;
    data['lastName'] = this.lastName;
    if (Array.isArray(this.roles)) {
      data['roles'] = [];
      for (let item of this.roles) data['roles'].push(item);
    }
    data['username'] = this.username;
    data['isAuthenticated'] = this.isAuthenticated;
    data['profile'] = this.profile ? this.profile.toJSON() : <any>undefined;
    data['newDocuments'] = this.newDocuments;
    data['newBillingDocuments'] = this.newBillingDocuments;
    data['newTickets'] = this.newTickets;
    data['newCommunications'] = this.newCommunications;
    data['hasNotifications'] = this.hasNotifications;
    data['id'] = this.id;
    data['ati'] = this.ati ? this.ati.toJSON() : <any>undefined;
    if (Array.isArray(this.customerSubRoles)) {
      data['customerSubRoles'] = [];
      for (let item of this.customerSubRoles) data['customerSubRoles'].push(item);
    }
    if (Array.isArray(this.backOfficeSubRoles)) {
      data['backOfficeSubRoles'] = [];
      for (let item of this.backOfficeSubRoles) data['backOfficeSubRoles'].push(item);
    }
    return data;
  }
}

export interface IUserProfileDTO {
  firstName?: string | undefined;
  lastName?: string | undefined;
  roles?: string[] | undefined;
  username?: string | undefined;
  isAuthenticated?: boolean;
  profile?: ProfileInfoDTO;
  newDocuments?: number;
  newBillingDocuments?: number;
  newTickets?: number;
  newCommunications?: number;
  hasNotifications?: boolean;
  id?: string | undefined;
  ati?: AtiDetailDTO;
  customerSubRoles?: CustomerRoleClaim[] | undefined;
  backOfficeSubRoles?: BackOfficePermissionRoleClaim[] | undefined;
}

export class UserProfileFirstAccessDTO implements IUserProfileFirstAccessDTO {
  userId?: string | undefined;
  username?: string | undefined;
  email?: string | undefined;
  firstName?: string | undefined;
  lastName?: string | undefined;
  emailConfirmed?: boolean;

  constructor(data?: IUserProfileFirstAccessDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.userId = _data['userId'];
      this.username = _data['username'];
      this.email = _data['email'];
      this.firstName = _data['firstName'];
      this.lastName = _data['lastName'];
      this.emailConfirmed = _data['emailConfirmed'];
    }
  }

  static fromJS(data: any): UserProfileFirstAccessDTO {
    data = typeof data === 'object' ? data : {};
    let result = new UserProfileFirstAccessDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['userId'] = this.userId;
    data['username'] = this.username;
    data['email'] = this.email;
    data['firstName'] = this.firstName;
    data['lastName'] = this.lastName;
    data['emailConfirmed'] = this.emailConfirmed;
    return data;
  }
}

export interface IUserProfileFirstAccessDTO {
  userId?: string | undefined;
  username?: string | undefined;
  email?: string | undefined;
  firstName?: string | undefined;
  lastName?: string | undefined;
  emailConfirmed?: boolean;
}

export class UserUpdateDTO implements IUserUpdateDTO {
  firstName?: string | undefined;
  lastName?: string | undefined;
  referenceEmail?: string | undefined;
  siteCodes?: string[] | undefined;

  constructor(data?: IUserUpdateDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.firstName = _data['firstName'];
      this.lastName = _data['lastName'];
      this.referenceEmail = _data['referenceEmail'];
      if (Array.isArray(_data['siteCodes'])) {
        this.siteCodes = [] as any;
        for (let item of _data['siteCodes']) this.siteCodes!.push(item);
      }
    }
  }

  static fromJS(data: any): UserUpdateDTO {
    data = typeof data === 'object' ? data : {};
    let result = new UserUpdateDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['firstName'] = this.firstName;
    data['lastName'] = this.lastName;
    data['referenceEmail'] = this.referenceEmail;
    if (Array.isArray(this.siteCodes)) {
      data['siteCodes'] = [];
      for (let item of this.siteCodes) data['siteCodes'].push(item);
    }
    return data;
  }
}

export interface IUserUpdateDTO {
  firstName?: string | undefined;
  lastName?: string | undefined;
  referenceEmail?: string | undefined;
  siteCodes?: string[] | undefined;
}

export class ApiException extends Error {
  message: string;
  status: number;
  response: string;
  headers: { [key: string]: any };
  result: any;

  constructor(message: string, status: number, response: string, headers: { [key: string]: any }, result: any) {
    super();

    this.message = message;
    this.status = status;
    this.response = response;
    this.headers = headers;
    this.result = result;
  }

  protected isApiException = true;

  static isApiException(obj: any): obj is ApiException {
    return obj.isApiException === true;
  }
}

function throwException(
  message: string,
  status: number,
  response: string,
  headers: { [key: string]: any },
  result?: any
): any {
  if (result !== null && result !== undefined) throw result;
  else throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any | undefined): obj is AxiosError {
  return obj && obj.isAxiosError === true;
}
